<!-- 描述信息 -->
<template>
  <div>
    <p class="indentation title-sub" v-for="item in dataList" :key="item">{{ item }}</p>
  </div>
</template>

<script>
export default {
  name: 'RetractList',
  components: {},
  props: {
    dataList: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {

  },
  mounted() {
  },
}
</script>
<style scoped>
</style>